import axios from "../common";

export const ApiNotificationList = async () => {
    let url = "/notifications/list"
    return await axios.get(url, {withCredentials: true})
}

export const ApiNotificationDownload = async (notificationId: number) => {
    let url = "/notifications/" + notificationId + "/download"
    return await axios.get(url, {withCredentials: true, responseType: 'blob'})
}